module.exports = __webpack_public_path__ + "static/img/蒙版组 29@2x.f381cce.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/蒙版组 29@2x.png
// module id = 7Tdm
// module chunks = 1